import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../lib/auth.jsx';

// Gates a route by auth + (optional) allowed roles. Redirects to /login if
// unauthenticated, or to the role's home if the role isn't permitted.
export function RouteGuard({ children, allow }) {
  const { session, role, loading } = useAuth();
  const loc = useLocation();

  if (loading) {
    return (
      <div className="center">
        <div className="spinner" />
        <span className="muted">กำลังโหลด…</span>
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/login" replace state={{ from: loc.pathname }} />;
  }

  if (allow && role && !allow.includes(role)) {
    // Staff hitting a manager-only page lands on their own page.
    return <Navigate to="/me" replace />;
  }

  return children;
}
